var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loadOk)?_c('div',[_c('router-view')],1):_vm._e(),(_vm.smegmaType)?_c('div',{staticStyle:{"display":"contents"}},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AFSJx dgmlwU",staticStyle:{"background-color":"rgba(18,125,171)"}},[_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }